export type ResponsiveSize = [number | null, number | null, number][];
export enum ResponsivePresetKeys {
  EXPANDABLE_CARD_CAROUSEL,
  EXPANDABLE_CARD_GRID,
  STATIC_CARD,
  ARTIST_SEARCH_RESULT,
  BILLBOARD,
  BOTTOM_NAVIGATION_PROFILE,
  BILLBOARD_TYPOGRAPHY,
  TRAILER,
  SEASON_EPISODES,
}

export type ResponsivePresetObject = {
  [key in ResponsivePresetKeys]: ResponsiveSize;
};

export const ResponsivePresets: ResponsivePresetObject = {
  [ResponsivePresetKeys.EXPANDABLE_CARD_GRID]: [
    [2560, null, 565],
    [1920, 2560, 565],
    [1440, 1920, 499],
    [1024, 1440, 513],
  ],
  [ResponsivePresetKeys.EXPANDABLE_CARD_CAROUSEL]: [
    [1920, null, 690],
    [1440, 1920, 690],
    [1024, 1440, 690],
  ],
  [ResponsivePresetKeys.STATIC_CARD]: [
    [2560, null, 438],
    [1920, 2560, 438],
    [1440, 1920, 325],
    [1024, 1440, 240],
  ],
  [ResponsivePresetKeys.ARTIST_SEARCH_RESULT]: [
    [2560, null, 784],
    [1920, 2560, 784],
    [1440, 1920, 420],
    [1024, 1440, 294],
  ],
  [ResponsivePresetKeys.BILLBOARD]: [
    [2560, null, 1440],
    [1920, 2560, 1024],
    [1440, 1920, 768],
    [1024, 1440, 690],
  ],
  [ResponsivePresetKeys.BOTTOM_NAVIGATION_PROFILE]: [[1, null, 240]],
  [ResponsivePresetKeys.BILLBOARD_TYPOGRAPHY]: [[1, null, 284]],
  // [ResponsivePresetKeys.BILLBOARD_TYPOGRAPHY]: [
  //   [2560, null, 384],
  //   [1920, 2560, 284],
  //   [1440, 1920, 288],
  //   [1024, 1440, 216],
  // ],
  [ResponsivePresetKeys.TRAILER]: [
    [2560, null, 551],
    [1920, 2560, 551],
    [1440, 1920, 410],
    [1024, 1440, 304],
  ],
  [ResponsivePresetKeys.SEASON_EPISODES]: [
    [2560, null, 435],
    [1920, 2560, 435],
    [1440, 1920, 408],
    [1024, 1440, 409],
  ],
};
